import { Button, TextField, Box, CircularProgress } from "@mui/material";
import React, { useEffect, useState } from "react";
import { ReactComponent as PasswordVisible } from "../Icons/PasswordVisible.svg";
import { ReactComponent as PasswordInvisible } from "../Icons/PasswordInvisible.svg";
import CREATE from "../Icons/create.png";
import { ReactComponent as BackArrow } from "../Icons/BackArrow.svg";
import { emailRegex } from "../Utils";
import {
  ErrorTypography,
  StyledPrimaryTypography,
  StyledTypography,
} from "../Theme";
import {
  getMenu,
  login,
  setLoginSliceToNull,
  setUserDetails,
} from "../Redux/Feature/Login/loginSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setActiveStep,
  setPropertyId,
  setUserRole,
} from "../Redux/Feature/PropertyDetails/propertyDetailsSlice";
import { Toaster } from "../CommonComponents/modal";
import { toast, ToastContainer } from "react-toastify";

const Login = ({ setDisplayScreen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loginStatus } = useSelector((state) => state.Login);
  console.log("login", loginStatus);
  const [data, setData] = useState({ email: "", password: "" });
  const [errorText, setErrorText] = useState({ email: "", password: "" });
  const [responseError, setResponseError] = useState("");
  const [passwordType, setPasswordType] = useState("password");
  const [loadingBtn, setLoadingBtn] = useState(false);

  useEffect(() => {
    if (loginStatus != null) {
      setLoadingBtn(false);
      if (loginStatus.success) {
        if (loginStatus.data.user_details.user_role == 1) {
          if (loginStatus.data.property_status.status === "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000;
            localStorage.clear();
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
            // dispatch(setPropertyId(loginStatus.data.property_status.id))
            navigate("/propertyDetailsSetup");
            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          } else if (loginStatus.data.property_status.status !== "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
            localStorage.clear();
            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            toast.success("Login Successful");
            setTimeout(() => {
              navigate("dashboard");
            }, 1000);

            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          }
        } else if (loginStatus.data.user_details.user_role == 3) {
          if (loginStatus.data.property_status.status === "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000;
            localStorage.clear();
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
            // dispatch(setPropertyId(loginStatus.data.property_status.id))
            navigate("/propertyDetailsSetup");
            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          } else if (loginStatus.data.property_status.status !== "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
            localStorage.clear();
            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            toast.success("Login Successful");
            setTimeout(() => {
              navigate("/upcoming_visitor");
            }, 1000);

            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          }
        } else if (loginStatus.data.user_details.user_role == 2) {
          if (loginStatus.data.property_status.status === "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000;
            localStorage.clear();
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
            // dispatch(setPropertyId(loginStatus.data.property_status.id))
            navigate("/propertyDetailsSetup");
            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          } else if (loginStatus.data.property_status.status !== "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
            localStorage.clear();
            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            toast.success("Login Successful");
            setTimeout(() => {
              navigate("dashboard");
            }, 1000);

            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          }
        } else if (loginStatus.data.user_details.user_role == 4) {
          if (loginStatus.data.property_status.status === "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000;
            localStorage.clear();
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
            // dispatch(setPropertyId(loginStatus.data.property_status.id))
            navigate("/propertyDetailsSetup");
            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          } else if (loginStatus.data.property_status.status !== "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
            localStorage.clear();
            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            toast.success("Login Successful");
            setTimeout(() => {
              navigate("upcoming_visitor");
            }, 1000);

            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          }
        }else if (loginStatus.data.user_details.user_role == 5) {
          if (loginStatus.data.property_status.status === "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000;
            localStorage.clear();
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            // dispatch(setActiveStep(loginStatus.data.property_status.completed_step))
            // dispatch(setPropertyId(loginStatus.data.property_status.id))
            navigate("/propertyDetailsSetup");
            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          } else if (loginStatus.data.property_status.status !== "onboarding") {
            console.log('called')
            const expiresIn = loginStatus.data.token?.expires_in;
            const expiresAt = Date.now() + expiresIn * 1000; // Calculate expiry timestamp
            localStorage.clear();
            localStorage.setItem(
              "propertyStatus",
              JSON.stringify(loginStatus.data.property_status)
            );
            localStorage.setItem(
              "accessToken",
              loginStatus.data.token.access_token
            );
            localStorage.setItem(
              "refreshToken",
              loginStatus.data.token.refresh_token
            );
            localStorage.setItem(
              "expireTime",
              expiresAt
            );

            localStorage.setItem(
              "userDetails",
              JSON.stringify(loginStatus.data.user_details)
            );
            toast.success("Login Successful");
            setTimeout(() => {
              navigate("dashboard");
            }, 1000);

            dispatch(setLoginSliceToNull());
            dispatch(setPropertyId(loginStatus.data.property_status.id));
            dispatch(setUserRole(loginStatus.data.user_details.user_role));
            dispatch(setUserDetails(loginStatus.data.user_details));
          }
        }
      } else {
        setResponseError(loginStatus.error);
      }
    }
  }, [loginStatus]);


   useEffect(() => {
    if (loginStatus?.detail) {
      setResponseError(loginStatus.detail);
    }
  }, [loginStatus]);

  const handleData = (e) => {
    let { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
    setErrorText({
      ...errorText,
      [name]: "",
    });
    setResponseError("");
  };

  const validate = () => {
  let isError = false;

  for (let key in data) {

    // Empty field validation
    if (!data[key]) {
      let message = "This field is required";

      if (key === "email") message = "Please enter your email address";
      if (key === "password") message = "Please enter your password";

      setErrorText((prev) => ({
        ...prev,
        [key]: message,
      }));

      isError = true;
      continue;
    }

    // Email format validation
    if (key === "email" && !emailRegex.test(data[key])) {
      setErrorText((prev) => ({
        ...prev,
        email: "Please enter a valid email address",
      }));
      isError = true;
    }
  }

  return isError;
};

  const handleLogin = (e) => {
    e.preventDefault();
    if (loadingBtn) return;
    let isError = validate();
    if (!isError) {
      dispatch(setLoginSliceToNull());
      setLoadingBtn(true);
      dispatch(login({ email: data.email, password: data.password }));
    }
  };


  return (
    <>
    <ToastContainer autoClose="2000"
      position="bottom-center"
      toastClassName="custom-toast"
      hideProgressBar={true}
      />
      {/* <BackArrow
        onClick={() => setDisplayScreen("")}
        style={{ cursor: "pointer" }}
      /> */}
      <form onSubmit={handleLogin}>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
      <Box component={"img"} src={CREATE} alt="create" sx={{width:300, height:70, cursor:'pointer'}}/>
      </Box>
      <StyledPrimaryTypography style={{ marginTop: "25px" }}>
        Log In{" "}
      </StyledPrimaryTypography>

      <TextField
        name="email"
        value={data.email}
        onChange={handleData}
        placeholder="Email"
        InputProps={{ disableUnderline: true }}
        sx={{ mt: 3, mb: 2 }}
        inputProps={{ maxLength: 125 }}
      />
      <ErrorTypography>{errorText.email}</ErrorTypography>
      <TextField
        type={passwordType}
        name="password"
        value={data.password}
        onChange={handleData}
        placeholder="Password"
        InputProps={{
          disableUnderline: true,
          endAdornment:
            passwordType === "password" ? (
              <PasswordVisible
                onClick={() => setPasswordType("text")}
                style={{ cursor: "pointer" }}
              />
            ) : (
              <PasswordInvisible
                onClick={() => setPasswordType("password")}
                style={{ cursor: "pointer" }}
              />
            ),
        }}
        sx={{ mt: 3, mb: 2 }}
      />
      <ErrorTypography>{errorText.password}</ErrorTypography>
      <ErrorTypography>{responseError}</ErrorTypography>
      <Button
        disabled={loadingBtn}
        type="submit"
        fullWidth
        variant="contained"
        sx={{ my: 2 }}
      >
        {" "}
        {loadingBtn ? <CircularProgress size={25} /> : "Login"}
      </Button>
      <StyledTypography>Don't have an account? <span style={{ cursor: "pointer", color: "#800000" }} onClick={() => setDisplayScreen("signup")}>Sign Up</span></StyledTypography>

      <StyledTypography
        mt={1}
        textAlign="start"
        sx={{ cursor: "pointer" }}
        color="#4D5761 !important"
        onClick={() => {
          setDisplayScreen("recoverPassword");
        }}
      >
        Forgot password?
      </StyledTypography>
      </form>
    </>
  );
};

export default Login;
